export const DOMAIN = 'auth.customer.activity';
